import { render, staticRenderFns } from "./Roleta.vue?vue&type=template&id=a3bf8e8e&scoped=true&lang=pug&"
import script from "./Roleta.vue?vue&type=script&lang=js&"
export * from "./Roleta.vue?vue&type=script&lang=js&"
import style0 from "./Roleta.vue?vue&type=style&index=0&id=a3bf8e8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf8e8e",
  null
  
)

export default component.exports